import * as Yup from "yup";
import { DropdownValidation, StringValidation } from "../PlanSchema";

export const PerspectiveSchema = Yup.object().shape({
  perspective:Yup.object().shape({
        label: Yup.string().required("Perspective is required"),
        value: Yup.string().required("Required")
    }).required('Required').nullable(),
  weight: Yup.number().required()
});

export const ObjectiveSchema = Yup.object().shape({
  objective: Yup.object().shape({
        label: Yup.string().required("Objective is required"),
        value: Yup.string().required("Required")
    }).required('Required').nullable(),
  weight: Yup.number().required()
});